<div class="nk-footer nk-footer-fluid bg-lighter">
    <div class="container-xl wide-xl">
        <div class="nk-footer-wrap">
            <div class="col-lg-6 order-last">
                <ul class="nav nav-sm justify-content-center justify-content-lg-end">
                    <li class="nav-item">
                        <div class="nav-link"><span class="ms-1">{{version}}</span>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="col-lg-6">
                <div class="nk-footer-copyright"> &copy; 2024 {{'copyright'|translate}} <a href="https://ine.cv"
                        target="_blank">INE</a>.
                </div>
            </div>
        </div>
    </div>
</div>